import React from "react";
import Navbar from "./Navbar";
import FooterSection from "./footersection";
import "./terms_of_service_page.css";


const TermsOfServiceContent=  () =>{
    return(
        <div>
            <div className="terms-container">
                <div>
                    <h1>Terms Of Use - StockArchives</h1>
                    <p>
                        <strong>Effective Date:</strong> 09/05/2025
                    </p>
                    <p>
                        <strong>Last Updated:</strong> 09/05/2025
                    </p>
                </div>
                <div>
                    <p>
                    Welcome to StockArchives. By accessing or using our website,
                    API, or services, you agree to be bound by these Terms of Use. 
                    If you do not agree, please do not use our services.
                    </p>
                </div>
                <div>
                    <h2>1. Use of Services</h2>
                    <p>
                    stockArchives provides access to historical financial data 
                    (including balance sheets, income statements, cash flows, 
                    CPI, GDP, etc.) for stocks and ETFs through an API and web 
                    interface. You agree to use this data for informational and 
                    non-commercial purposes only unless otherwise authorized in writing.
                    </p>
                </div>
                <div>
                    <h2>2. Account Registration</h2>
                    <p>
                    A free account grants limited access to financial data. 
                    You are responsible for maintaining the confidentiality 
                    of your account credentials and all activities under your 
                    account.
                    </p>
                </div>
                <div>
                    <h2>3. Data Accuracy and Disclaimer</h2>
                    <p>While we strive to provide accurate and up-to-date 
                        data, stockArchives does not guarantee the accuracy, 
                        completeness, or timeliness of any data provided. 
                        We source data from third parties and make no 
                        representations or warranties regarding its reliability.</p>
                    <p>You agree not to rely solely on data from stockArchives 
                        for any financial, legal, or investment decision.</p>
                </div>
                <div>
                    <h2>4. No Investment Advice</h2>
                    <p>
                    The information provided by stockArchives is for informational 
                    purposes only and does not constitute financial, investment, or 
                    legal advice. You acknowledge and agree that you use this information 
                    at your own risk and that stockArchives will not be liable for any 
                    losses or damages incurred through use of the data. 
                    </p>
                </div>
                <div>
                    <h2>5. Prohibited Activities</h2>
                    <p>You may not:</p>
                    <ul>
                        <li>Resell or redistribute API data without permission</li>
                        <li>Use the service for unlawful purposes</li>
                        <li>Attempt to reverse-engineer or overload the service</li>
                        <li>Scrape or extract content outside authorized API usage</li>
                    </ul>
                </div>
                <div>
                    <h2>6. Termination</h2>
                    <p>We reserve the right to suspend or 
                        terminate your account at our discretion, 
                        especially for violations of these Terms.</p>
                </div>
                <div>
                    <h2>7. Limitation of Liability</h2>
                    <p>To the fullest extent permitted by law, 
                        stockArchives shall not be liable for 
                        any indirect, incidental, special, consequential, 
                        or punitive damages, including loss of profits, data, 
                        or business opportunity, arising out of your use or 
                        inability to use the service.</p>

                </div>
                <div>
                    <h2>8. Governing Law</h2>
                    <p>These Terms are governed by and construed in 
                        accordance with the laws of the State of Florida, 
                        United States.</p>
                </div>
                <div>
                    <h2>9. Changes to the Terms</h2>
                    <p>We may update these Terms from time to time. 
                        Your continued use after changes indicates acceptance.</p>
                </div>
            </div>
        </div>
    );
}

export default TermsOfServiceContent;